import { BaseApiService } from '@/services/base-service';
import {
  ApiPagination,
  BaseResponse,
  Filters,
  FiltersPagination,
  Response,
} from '@/types';
import { del_mask, prepare_formdata } from '@/utils';
import { Subpartners, SubpartnerFileUploadData } from '../types';

interface SubpartnersList extends BaseResponse, ApiPagination {
  data: {
    items: Subpartners.Subpartner[],
    regions: string[],
    cities: string[],
  }
}

interface SubpartnerSales extends BaseResponse, ApiPagination {
  data: Subpartners.SubpartnerSales[],
}

export class SubpartnersService extends BaseApiService {
  private readonly base_path = 'partner';

  private readonly sales_url = `${this.base_path}/subpartners/sales`;

  cancel_token_urls = [this.sales_url];

  async get_subpartners_sales(filters: FiltersPagination<null>): Promise<SubpartnerSales> {
    const { data } = await this.http_client.get<SubpartnerSales>(this.sales_url, {
      params: {
        limit: filters.pagination.limit,
        page: filters.pagination.page,
        sort: filters.pagination.sort,
        sort_type: filters.pagination.sort_type,
      },
    });

    return data;
  }

  async get_subpartners(payload: FiltersPagination<Filters>): Promise<SubpartnersList> {
    const url = `${this.base_path}/subpartners`;

    const { data } = await this.http_client.get<SubpartnersList>(url, {
      params: {
        filters: payload.filters,
        limit: payload.pagination.limit,
        page: payload.pagination.page,
        sort: payload.pagination.sort,
        sort_type: payload.pagination.sort_type,
      },
    });

    return data;
  }

  async get_subpartner_by_id(id: string | number): Promise<Response<Subpartners.Subpartner>> {
    const url = `${this.base_path}/subpartners/${id}`;
    const { data } = await this.http_client.get<Response<Subpartners.Subpartner>>(url);

    return data;
  }

  async update_subpartner(subpartner: Subpartners.Subpartner): Promise<BaseResponse> {
    const url = `${this.base_path}/subpartners/${subpartner.id}`;
    const payload = subpartner;

    payload.telephone = del_mask(payload.telephone);
    payload.inn_subpartner = del_mask(payload.inn_subpartner);
    payload.kpp_subpartner = del_mask(payload.kpp_subpartner);

    const { data } = await this.http_client.patch<BaseResponse>(url, payload);

    return data;
  }

  async send_subpartner_sales(file: File): Promise<Response<SubpartnerFileUploadData>> {
    const url = `${this.base_path}/subpartners/sales`;
    const { data } = await this.http_client.post<Response<SubpartnerFileUploadData>>(url, prepare_formdata({ file }));

    return data;
  }
}

export const default_subpartner = (): Subpartners.Subpartner => ({
  name_subpartner: '',
  inn_subpartner: '',
  kpp_subpartner: '',
  city: '',
  region: '',
  email: '',
  contact_person: '',
  telephone: '',
});
